import { ComplianceEntityType } from "@wingspanhq/wingspan-api-sdk";
import { complianceEntitiesApi } from "@api";
import { FlowMEChangeContext } from "..";
import { useWSMutation, WSMutationConfig } from "../../../../../query/helpers";
import { useQueryPrimaryComplianceEntity } from "../../../../../shared/hooks/useQueryPrimaryComplianceEntity";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { WSServiceError } from "../../../../../utils/serviceHelper";

export const useMutationSubmitImmaterialLegalName = (
  config?: WSMutationConfig<void, WSServiceError, any>
) => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();
  const queryCustomerEntity = useQueryPrimaryComplianceEntity();

  return useWSMutation(async () => {
    const entity = queryCustomerEntity.data;

    if (!entity?.id) {
      throw new Error("No compliance entity found");
    }

    if (entity.type === ComplianceEntityType.INDIVIDUAL) {
      await complianceEntitiesApi.updateComplianceEntity({
        complianceEntityId: entity.id,
        complianceEntityUpdate: {
          individualLegalName: {
            givenName: context.individualLegalName?.firstName || undefined,
            middleNames: context.individualLegalName?.middleName || undefined,
            familyName: context.individualLegalName?.lastName || undefined
          }
        }
      });
    } else {
      // A business legal name has no field on the update body, so the rename can
      // only go through the advance transition — a material change on v3, unlike
      // the immaterial change request v2 took. The DBA rides along.
      await complianceEntitiesApi.advanceComplianceEntity({
        complianceEntityId: entity.id,
        complianceEntityAdvanceRequest: {
          type: entity.type,
          jurisdictionCountry: entity.jurisdictionCountry,
          legalName: context.businessLegalName?.legalBusinessName || undefined,
          doingBusinessAs: context.businessLegalName?.dba || undefined,
          effectiveDate: context.reason?.effectiveAt
        }
      });
    }

    setContext({ nameChanged: true });
  }, config);
};
